import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './callback.service.css';
import ITokenService from '../../interfaces/ITokenService';
import FormDataService from '../FormData/formData.service';
import DtoToDomainMapper from '../../mappers/dtoToDomain.mapper';
import TokenService from './TokenService';
import { appInsights } from '../../AppInsights';

type CallBackServiceSACBLProps = {
  tokenService: ITokenService
};

const CallBackServiceSACBL = (props: CallBackServiceSACBLProps) => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  async function startAuthorization(input: string) {
    const accessToken = sessionStorage.getItem('access_token');
    if (accessToken === undefined || accessToken === 'undefined' || accessToken == null) {
      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');
      const verifier: string = window.localStorage.getItem('code_verifier') || '';
      const urlencoded = new URLSearchParams();
      urlencoded.append('grant_type', 'authorization_code');

      urlencoded.append('code', input);
      urlencoded.append('code_verifier', verifier);
      urlencoded.append('redirect_uri', process.env.REACT_APP_REDIRECT_URI_NOT_ENCODED_SACBL || '');
      urlencoded.append('client_id', process.env.REACT_APP_CLIENT_ID_SACBL || '');

      const requestOptions: any = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow',
      };

      const pingUrl = process.env.REACT_APP_FEDERATION_TOKEN_URL || '';
      const response = await fetch(pingUrl, requestOptions);

      if (response.status === 200) {
        const res = await response.json();

        // If this errors out, we need to alert the user that something went wrong and NOT navigate them
        // Post MVP?
        const tokenHash = await props.tokenService.createTokenHash(res.access_token);
        props.tokenService.storeTokenHash(tokenHash, res.refresh_token, true);

        const upxSessionId = localStorage.getItem('upxSessionId');
        localStorage.removeItem('upxSessionId');
        appInsights.trackTrace({ message: `Successfully received access token for ${upxSessionId} sessionId.` });

        const formdata = await FormDataService.getDraftClinicalAndDocDto();
        const domainObj = DtoToDomainMapper.ToDomainObject(formdata.priorAuthorizationForm);

        if (domainObj.authorizationStatus.toUpperCase() === 'INCOMPLETE') {
          navigate(
            '/precertificationIntake',
            {
              state: {
                domainObject: domainObj,
                docs: formdata.docUploadFiles,
                sessionType: TokenService.resumeSession,
              },
            },
          );
        } else {
          navigate(
            '/additionalClinicalUpload',
            { state: { domainObject: domainObj, authorizationStatus: domainObj.authorizationStatus } },
          );
        }
      } else {
        const res = await response.json();
        const upxSessionId = localStorage.getItem('upxSessionId');
        localStorage.removeItem('upxSessionId');
        // eslint-disable-next-line max-len
        appInsights.trackException({ error: new Error(`Unable to get access token for ${upxSessionId} sessionId due to ${res.error} - ${res.error_description}`) });
      }
    }
  }

  // only run once signified by []
  useEffect(() => {
    const param = 'code';
    const code = searchParams.get(param);
    if (code) {
      const upxSessionId = localStorage.getItem('upxSessionId');
      appInsights.trackTrace({ message: `Received code from ping for ${upxSessionId} sessionId.` });
      searchParams.delete(param);
      setSearchParams(searchParams);
      startAuthorization(code);
    } else {
      const errordescription = searchParams.get('error_description');
      const error = searchParams.get('error');
      const upxSessionId = localStorage.getItem('upxSessionId');
      localStorage.removeItem('upxSessionId');
      // eslint-disable-next-line max-len
      appInsights.trackException({ error: new Error(`Unbale to get code for ${upxSessionId} session due to ${error} - ${errordescription}`) });
    }
  }, []);

  return (
    <div data-testid="Callback" />
  );
};

export default CallBackServiceSACBL;
